import { render, staticRenderFns } from "./RecommendFocusNewsItem.vue?vue&type=template&id=74ecb73b&scoped=true"
import script from "./RecommendFocusNewsItem.vue?vue&type=script&lang=js"
export * from "./RecommendFocusNewsItem.vue?vue&type=script&lang=js"
import style0 from "./RecommendFocusNewsItem.vue?vue&type=style&index=0&id=74ecb73b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ecb73b",
  null
  
)

export default component.exports